<template>
  <div class="row py-5 py-md-7" id="industry-focus">
    <div class="col-12 offset-md-3 col-md-8 col-lg-7 mb-4">
      <h2>Core Industry Focus</h2>
      <h3 class="subhead gold-text mb-4">
        Healthcare and Real Estate Expertise
      </h3>
      <p>
        We specialize in operating intensive real estate based businesses such
        as health care services, hospitality, among others.
      </p>
      <p>
        The combination of our extensive knowledge of both real estate and
        operations uniquely positions us among our peers to offer our clients
        creative unbiased advice and financial solutions.
      </p>
    </div>
    <div class="col-12 offset-md-3 col-md-8 col-lg-7">
      <div class="row">
        <div class="col-12 col-md-5">
          <ul>
            <li>Healthcare REITs</li>
            <li>Senior Housing</li>
            <li>Medical Office &amp; Life Science</li>
            <li>Post Acute &amp; Skilled Nursing</li>
            <li>Ancillary Services</li>
          </ul>
        </div>
        <div class="col-12 col-md-5">
          <ul>
            <li>Hospitality</li>
            <li>Commercial REITs</li>
            <li>Multi-Family</li>
            <li>Industrial/Office</li>
            <li>Specialty Finance</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0;
  list-style-position: inside;
  font-family: europa, sans-serif;
  font-weight: 400;
}
</style>
